import Raven from 'raven-js';
import { useCallback, useState, useEffect } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { View } from 'foundations-components/components/View';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTracker } from 'setup-guide-components/hooks/tracking';
import { captureNetworkError } from 'growth-onboarding-reliability/utils/raven';
import { changeEnrolledInUserGuide, isEnrolledInUserGuide } from 'onboarding-settings-client/api/enrollment';
import { useGlobalHomeEligibility } from 'setup-guide-api/dataFetchingClient/queries/globalHomeEligibility';
import { CHANGE_DEFAULT_HOMEPAGE_ROUTE } from '../constants/routeConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnrollmentFooterPlaceholder = () => /*#__PURE__*/_jsx(View, {
  blockSize: "24px",
  "data-test-id": "enrollment-footer-placeholder",
  inlineSize: "100%"
});
const GLOBAL_HOME_URL = `/global-home/${PortalIdParser.get()}`;
const EnrollmentFooter = () => {
  const {
    trackUserInteraction
  } = useTracker();
  const [isEnrolled, setIsEnrolled] = useState(undefined);
  const {
    isEligibleForGlobalHome,
    hasGlobalHomeError,
    loading: isLoadingGlobalHome
  } = useGlobalHomeEligibility();
  const shouldRedirectToGlobalHome = isEligibleForGlobalHome || hasGlobalHomeError;
  useEffect(() => {
    isEnrolledInUserGuide().then(userIsEnrolled => {
      setIsEnrolled(Boolean(userIsEnrolled));
    }).catch(error => {
      Raven.captureException(error, {
        extra: {
          message: 'error while checking user enrollment status'
        }
      });
      // Sane default, more likely than not...
      setIsEnrolled(true);
    });
  }, []);
  const trackClickUnenroll = useCallback(() => {
    trackUserInteraction('unenroll from user guide');
  }, [trackUserInteraction]);
  const unenrollUserForGlobalHome = useCallback(() => {
    trackUserInteraction('unenroll from user guide');
    changeEnrolledInUserGuide({
      isEnrolled: false
    }).catch(captureNetworkError);
  }, [trackUserInteraction]);
  if (!isEnrolled || isLoadingGlobalHome) {
    // Don't render yet, until we know if the user is enrolled or not
    return /*#__PURE__*/_jsx(EnrollmentFooterPlaceholder, {});
  }
  if (shouldRedirectToGlobalHome) {
    return /*#__PURE__*/_jsx(View, {
      "data-test-id": "enrollment-global-home",
      paddingBlockEnd: "600",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        elements: {
          Link
        },
        message: "app.unenroll_jsx",
        options: {
          onClick: unenrollUserForGlobalHome,
          href: GLOBAL_HOME_URL
        }
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "enrollment",
    paddingBlockEnd: "600",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      elements: {
        Link: UIRouterLink
      },
      message: "app.unenroll_jsx",
      options: {
        onClick: trackClickUnenroll,
        to: CHANGE_DEFAULT_HOMEPAGE_ROUTE
      }
    })
  });
};
export default EnrollmentFooter;